/***********************  ADD PROJECT ****************************************/

import { DELETE_ASSIGN_LEAD, DELETE_ASSIGN_LEAD_ERR } from '../../actionTypes/leadsType'
import { deleteAssignLeadApi } from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'


export const deleteAssignLead = payload => async dispatch => {
    try {
        console.log('accessToken',accessToken(),payload)
        let results = await axios.post(`${deleteAssignLeadApi}`, payload, await accessToken())
         console.log("Delete Assign Lead", results)
        let data = results && results.data
        dispatch({
            type: DELETE_ASSIGN_LEAD,
            payload: data || [],
        });
    } catch (error) {
        dispatch({
            type: DELETE_ASSIGN_LEAD_ERR,
            payload: error.response
        });
    }
}

/***********************  ADD PROJECT ****************************************/